export default __webpack_public_path__ + "static/media/hero-globe1.69585ee0.png";